import React from 'react'
import { PercentageText } from '../../../Global'

export const TableDataCellCtr = ({ dataValue }: { dataValue?: number }) => {
  return <PercentageText value={Number(dataValue)} />
}
